import { ECancellationCase } from '../../dticketSubscriptionCancel';
import { IActionConfigBase } from '../types';

interface ICaseConfig {
	firstAction: IActionConfigBase;
	secondAction: IActionConfigBase | null;
}

interface IEditCaseOptions {
	isPauseEndingSoon?: boolean;
	hasPause?: boolean;
}

export const getEditCaseConfig = (
	cancellationCase: ECancellationCase,
	options?: IEditCaseOptions
): ICaseConfig => {
	const pauseWarningKey = options?.isPauseEndingSoon
		? 'warning.in_pause_ending'
		: 'warning.in_pause';
	switch (cancellationCase) {
		case ECancellationCase.Revoke:
			return {
				firstAction: {
					type: 'revoke',
					titleKey: 'edit_cancel.revoke.title',
					descriptionKey: 'edit_cancel.revoke.description',
					buttonKey: 'edit_cancel.revoke.button',
					buttonVariant: 'contained',
					buttonColor: 'primary',
				},
				// Hide "Choose pause instead" when subscription is already paused
				// or has a scheduled pause alongside the scheduled cancellation.
				secondAction: options?.hasPause
					? null
					: {
							type: 'pause',
							titleKey: 'edit_cancel.pause.title',
							descriptionKey: 'edit_cancel.pause.description',
							buttonKey: 'edit_cancel.pause.button',
							buttonVariant: 'outlined',
							buttonColor: 'primary',
					  },
			};

		case ECancellationCase.ActivePause:
			return {
				firstAction: {
					type: 'cancel',
					titleKey: 'in_pause.cancel.title',
					descriptionKey: 'in_pause.cancel.description',
					buttonKey: 'in_pause.cancel.button',
					buttonVariant: 'outlined',
					buttonColor: 'error',
					warningKey: pauseWarningKey,
				},
				secondAction: null,
			};

		case ECancellationCase.ActivePauseCancelOutTime:
			return {
				firstAction: {
					type: 'cancel',
					titleKey: 'normal.cancel.title',
					descriptionKey: 'normal.cancel.description',
					buttonKey: 'in_pause.cancel.button',
					buttonVariant: 'outlined',
					buttonColor: 'error',
					warningKey: pauseWarningKey,
				},
				secondAction: null,
			};

		case ECancellationCase.PendingPause:
			return {
				firstAction: {
					type: 'cancel',
					titleKey: 'pending_pause.cancel.title',
					descriptionKey: 'pending_pause.cancel.description',
					buttonKey: 'pending_pause.cancel.button',
					buttonVariant: 'outlined',
					buttonColor: 'error',
					warningKey: 'warning.pending_pause',
				},
				secondAction: null,
			};

		case ECancellationCase.PreorderCancelInTime:
			// Preordered subscriptions cannot be paused — only offer cancel.
			return {
				firstAction: {
					type: 'cancel',
					titleKey: 'preorder.cancel.title',
					descriptionKey: 'preorder.cancel.description',
					buttonKey: 'preorder.cancel.button',
					buttonVariant: 'outlined',
					buttonColor: 'error',
				},
				secondAction: null,
			};

		case ECancellationCase.PreorderCancelOutTime:
			// Preordered subscriptions cannot be paused — only offer cancel.
			return {
				firstAction: {
					type: 'cancel',
					titleKey: 'normal.cancel.title',
					descriptionKey: 'normal.cancel.description',
					buttonKey: 'normal.cancel.button',
					buttonVariant: 'outlined',
					buttonColor: 'error',
					warningKey: 'warning.preorder_out_of_time',
				},
				secondAction: null,
			};

		case ECancellationCase.CancelOutTime:
			return {
				firstAction: {
					type: 'pause',
					titleKey: 'normal.pause.title',
					descriptionKey: 'normal.pause.description',
					buttonKey: 'normal.pause.button',
					buttonVariant: 'outlined',
					buttonColor: 'primary',
				},
				secondAction: {
					type: 'cancel',
					titleKey: 'normal.cancel.title',
					descriptionKey: 'normal.cancel.description',
					buttonKey: 'normal.cancel.button',
					buttonVariant: 'outlined',
					buttonColor: 'error',
					warningKey: 'warning.out_of_time',
				},
			};

		case ECancellationCase.CancelInTime:
		default:
			return {
				firstAction: {
					type: 'pause',
					titleKey: 'normal.pause.title',
					descriptionKey: 'normal.pause.description',
					buttonKey: 'normal.pause.button',
					buttonVariant: 'outlined',
					buttonColor: 'primary',
				},
				secondAction: {
					type: 'cancel',
					titleKey: 'normal.cancel.title',
					descriptionKey: 'normal.cancel.description',
					buttonKey: 'normal.cancel.button',
					buttonVariant: 'outlined',
					buttonColor: 'error',
					infoKey: 'info.deadline_reminder',
				},
			};
	}
};
